import { render } from "./GroupPermissionPage.vue?vue&type=template&id=43f997d8&scoped=true&ts=true"
import script from "./GroupPermissionPage.vue?vue&type=script&lang=ts"
export * from "./GroupPermissionPage.vue?vue&type=script&lang=ts"

import "./GroupPermissionPage.vue?vue&type=style&index=0&id=43f997d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f997d8"]])

export default __exports__